'use strict';

var _createForOfIteratorHelper = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _wrapAsyncGenerator = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncIterator = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _asyncGeneratorDelegate = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _car = require('@ipld/car');

var TreewalkCarJoiner = /*#__PURE__*/function () {
  function TreewalkCarJoiner(cars) {
    _classCallCheck(this, TreewalkCarJoiner);

    this._cars = Array.from(cars);
    if (!this._cars.length) throw new Error('missing CARs');
  }

  _createClass(TreewalkCarJoiner, [{
    key: "car",
    value: function car() {
      var _this = this;

      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var reader, roots, _car$CarWriter$create, writer, out, writeCar;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                reader = _this._cars[0];
                _context3.next = 3;
                return _awaitAsyncGenerator(reader.getRoots());

              case 3:
                roots = _context3.sent;
                _car$CarWriter$create = _car.CarWriter.create(roots), writer = _car$CarWriter$create.writer, out = _car$CarWriter$create.out;

                writeCar = /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                    var written, writeBlocks, _iterator2, _step2, _reader;

                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            written = new Set();

                            writeBlocks = /*#__PURE__*/function () {
                              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(reader) {
                                var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, b;

                                return _regeneratorRuntime.wrap(function _callee$(_context) {
                                  while (1) {
                                    switch (_context.prev = _context.next) {
                                      case 0:
                                        _iteratorAbruptCompletion = false;
                                        _didIteratorError = false;
                                        _context.prev = 2;
                                        _iterator = _asyncIterator(reader.blocks());

                                      case 4:
                                        _context.next = 6;
                                        return _iterator.next();

                                      case 6:
                                        if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                                          _context.next = 16;
                                          break;
                                        }

                                        b = _step.value;

                                        if (!written.has(b.cid.toString())) {
                                          _context.next = 10;
                                          break;
                                        }

                                        return _context.abrupt("continue", 13);

                                      case 10:
                                        _context.next = 12;
                                        return writer.put(b);

                                      case 12:
                                        written.add(b.cid.toString());

                                      case 13:
                                        _iteratorAbruptCompletion = false;
                                        _context.next = 4;
                                        break;

                                      case 16:
                                        _context.next = 22;
                                        break;

                                      case 18:
                                        _context.prev = 18;
                                        _context.t0 = _context["catch"](2);
                                        _didIteratorError = true;
                                        _iteratorError = _context.t0;

                                      case 22:
                                        _context.prev = 22;
                                        _context.prev = 23;

                                        if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                                          _context.next = 27;
                                          break;
                                        }

                                        _context.next = 27;
                                        return _iterator.return();

                                      case 27:
                                        _context.prev = 27;

                                        if (!_didIteratorError) {
                                          _context.next = 30;
                                          break;
                                        }

                                        throw _iteratorError;

                                      case 30:
                                        return _context.finish(27);

                                      case 31:
                                        return _context.finish(22);

                                      case 32:
                                      case "end":
                                        return _context.stop();
                                    }
                                  }
                                }, _callee, null, [[2, 18, 22, 32], [23,, 27, 31]]);
                              }));

                              return function writeBlocks(_x) {
                                return _ref2.apply(this, arguments);
                              };
                            }();

                            _context2.prev = 2;
                            _context2.next = 5;
                            return writeBlocks(reader);

                          case 5:
                            _iterator2 = _createForOfIteratorHelper(_this._cars.slice(1));
                            _context2.prev = 6;

                            _iterator2.s();

                          case 8:
                            if ((_step2 = _iterator2.n()).done) {
                              _context2.next = 14;
                              break;
                            }

                            _reader = _step2.value;
                            _context2.next = 12;
                            return writeBlocks(_reader);

                          case 12:
                            _context2.next = 8;
                            break;

                          case 14:
                            _context2.next = 19;
                            break;

                          case 16:
                            _context2.prev = 16;
                            _context2.t0 = _context2["catch"](6);

                            _iterator2.e(_context2.t0);

                          case 19:
                            _context2.prev = 19;

                            _iterator2.f();

                            return _context2.finish(19);

                          case 22:
                            _context2.next = 27;
                            break;

                          case 24:
                            _context2.prev = 24;
                            _context2.t1 = _context2["catch"](2);
                            console.error(_context2.t1);

                          case 27:
                            _context2.prev = 27;
                            _context2.next = 30;
                            return writer.close();

                          case 30:
                            return _context2.finish(27);

                          case 31:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, null, [[2, 24, 27, 31], [6, 16, 19, 22]]);
                  }));

                  return function writeCar() {
                    return _ref.apply(this, arguments);
                  };
                }();

                writeCar();
                return _context3.delegateYield(_asyncGeneratorDelegate(_asyncIterator(out), _awaitAsyncGenerator), "t0", 8);

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }]);

  return TreewalkCarJoiner;
}();

exports.TreewalkCarJoiner = TreewalkCarJoiner;